var exports = {
  "kL": "xa15a2ab7--71559b--container",
  "VD": "xa15a2ab7--71559b--container--mortgage-annotations",
  "Qs": "xa15a2ab7--71559b--content",
  "Hs": "xa15a2ab7--71559b--photo-block",
  "sf": "xa15a2ab7--71559b--main-content-block",
  "nc": "xa15a2ab7--71559b--publisher-block",
  "cn": "xa15a2ab7--71559b--photo-label",
  "UJ": "xa15a2ab7--71559b--content-container",
  "Dn": "xa15a2ab7--71559b--transports-container",
  "X": "xa15a2ab7--71559b--ad-info",
  "Eq": "xa15a2ab7--71559b--builder-name-wrapper",
  "RJ": "xa15a2ab7--71559b--description-wrapper",
  "Ie": "xa15a2ab7--71559b--empty",
  "PM": "xa15a2ab7--71559b--close-block",
  "YB": "xa15a2ab7--71559b--mortgage-annotations",
};

module.exports = exports;
